/**
 * @flow
 * @format
 */

import _InputField from './InputField';

export default _InputField;



// WEBPACK FOOTER //
// ./src/components/InputField/index.js